export enum OperacaoEnum {
  Receita = 1,
  Despesa = -1,
}

export enum TipoRecorrenciaEnum {
  Fixa = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  Parcelada = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
}

export enum TipoDocumentoEnum {
  NotaFiscal = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  NFE = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
  Fatura = "5B04913A-6C46-4EBE-BFB3-F311EE9E0935",
  Recibo = "5B04913A-6C46-4EBE-BFB3-F311EE9E0936",
  CupomFiscal = "5B04913A-6C46-4EBE-BFB3-F311EE9E0937",
  Outros = "5B04913A-6C46-4EBE-BFB3-F311EE9E0938",
}

export enum TipoDivisaoContaEnum {
  DividirValorLiquidoEntreParcelas = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  ParcelasTeraoMesmoValorLiquido = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
}

export enum TipoEntidadeEnum {
  Fornecedor = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  Cliente = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
  Funcionario = "5B04913A-6C46-4EBE-BFB3-F311EE9E0925",
  // Transportadora = "5B04913A-6C46-4EBE-BFB3-F311EE9E0926",
  Condomino = "5B04913A-6C46-4EBE-BFB3-F311EE9E0927",
  Outros = "5B04913A-6C46-4EBE-BFB3-F311EE9E0928",
  OrgaoPublico = '5B04913A-6C46-4EBE-BFB3-F311EE9E0929',
}

export enum FormaRecorrenciaEnum {
  Anual = "5B04913A-6C46-4EBE-BFB3-F311EE9E0928",
  Semestral = "5B04913A-6C46-4EBE-BFB3-F311EE9E0929",
  Trimestral = "5B04913A-6C46-4EBE-BFB3-F311EE9E0930",
  Bimestral = "5B04913A-6C46-4EBE-BFB3-F311EE9E0931",
  Mensal = "5B04913A-6C46-4EBE-BFB3-F311EE9E0932",
  Quinzenal = "5B04913A-6C46-4EBE-BFB3-F311EE9E0933",
  Semanal = "5B04913A-6C46-4EBE-BFB3-F311EE9E0934",
  Diaria = "5B04913A-6C46-4EBE-BFB3-F311EE9E0935",
}

export enum StatusBoletoEnum {
  AguardandoRemessa = '5B04913A-6C46-4EBE-BFB3-F311EE9E0921',
  AguardandoRegistro = '5B04913A-6C46-4EBE-BFB3-F311EE9E0923',
  Disponivel = '5B04913A-6C46-4EBE-BFB3-F311EE9E0924',
  Cancelado = '5B04913A-6C46-4EBE-BFB3-F311EE9E0925',
  EmCancelamento = '5B04913A-6C46-4EBE-BFB3-F311EE9E0926',
  Erro = '5B04913A-6C46-4EBE-BFB3-F311EE9E0927',
}


